import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue from '../../../helpers/utils/getFlagValue';
import { IBreadcrumbs } from '../../../components/molecules/Breadcrumbs';
import { addQueueCouponServiceCount } from '../../../store/emarsys/action';
import { PAGE_NAME_SERVICE_COUPON } from '../../../constants/emarsys/service-coupon';

const useImpressionCouponService = (
  firstRef: React.RefObject<HTMLElement>,
  pageTitle: string = '',
  breadcrumbItems: IBreadcrumbs[],
  sectionName: string = '',
  carModel?: string[]
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue('EMARSYS');
      if (isAuth && isFlagActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: PAGE_NAME_SERVICE_COUPON.COUPON_SERVICE_LISTING_PAGE,
          page_url: window.location.href,
        };

        if (pageTitle) {
          valuePageView.page_title = pageTitle;
        }

        if (carModel && carModel.length > 0) {
          valuePageView.car_model = carModel.join(', ');
        }

        if (breadcrumbItems?.[1]?.name) {
          valuePageView.menu_cat_lvl1 = breadcrumbItems?.[1]?.name?.toLowerCase();
        }

        if (breadcrumbItems?.[2]?.name) {
          valuePageView.menu_cat_lvl2 = breadcrumbItems?.[2]?.name?.toLowerCase();
        }

        if (breadcrumbItems?.[3]?.name) {
          valuePageView.menu_cat_lvl3 = breadcrumbItems?.[3]?.name?.toLowerCase() || '';
          valuePageView.car_category = breadcrumbItems?.[3]?.name?.toLowerCase() || '';
        }

        if (sectionName) {
          valuePageView.section_name = sectionName;
        }

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueCouponServiceCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionCouponService;
